import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IItemDropdown } from 'src/app/core/interfaces/dropdown.models';
import { ActividadNegocioDialogService } from './actividad-negocio-dialog.service';
import {ActividadNegocioRequestPaginated} from "./actividad-negocio-dialog.model";
import { MessageConstants } from 'src/app/core/constants/message';
import { SecureStorageService } from 'src/app/core/validators/secure-storage.service';

@Component({
  standalone: false,
  selector: 'app-product-dialog',
  templateUrl: './actividad-negocio-dialog.component.html',
  styleUrls: ['./actividad-negocio-dialog.component.css']
})
export class ActividadNegocioDialogComponent implements OnInit {
  isFirstLoad: boolean = true;
  totalRows: number = 0;
  lsActividadNegocio: any;
  codigosMessage: any;
  mensajesMessage: any;

  readonly: boolean = false;

  loading: boolean = false;

  constructor(private ActividadNegocioDialogService: ActividadNegocioDialogService
    , public ref: DynamicDialogRef
    , public config: DynamicDialogConfig
    , private secureStorageService: SecureStorageService
    , private cdr: ChangeDetectorRef
  ){
      this.readonly = config.data.readonly
  }

  ngOnInit(): void {
    this.loading = true;

    const companyId = this.secureStorageService.getData("CompanyId");
    let ActividadNegocioReq: ActividadNegocioRequestPaginated = {
      CompanyId: companyId,
      Nombre:'',
      Codigo:''
    };
    this.getActividadNegocioData(ActividadNegocioReq);
  }


  getActividadNegocioData(request: ActividadNegocioRequestPaginated){

    [this.codigosMessage, this.mensajesMessage] = MessageConstants;
    this.ActividadNegocioDialogService.getPaginated(request)
      .subscribe(
        {
          next: (data) => {
            let dataTmp = data;
            if(dataTmp) {
              this.lsActividadNegocio = dataTmp;
            }
            this.cdr.detectChanges();
          },
          error: (error) => {
            if(error){
              console.log(error);
            }
            this.cdr.detectChanges();
          },
          complete: () => {
            this.loading = false;
            this.cdr.detectChanges();
          }
        }
      );
  }

  onRowDblClick(event: any, dataSelected: any){

    if(this.readonly)return;
    
    if(dataSelected){
      let _description = ((dataSelected.Nombre) ? dataSelected.Nombre : "" ) ;
      let itemDropdown: IItemDropdown = {
        code: dataSelected.Id,
        description: _description,
        dataSerialize: JSON.stringify(dataSelected)
      }
      this.ref.close(itemDropdown);
    }

  }

}
